<template>
  <div>
    <header class="bar bar-nav">
      <button class="button button-link button-nav pull-left">
        <span class="icon icon-left goback" @click="goback()" style="color: gray">  <span class="goback" style="margin-left: 5.5rem;color:gray;">
          联系我们
        </span></span>
      </button>

    </header>
    <div class="content">
      <div class="list-block">
        <ul>
          <!-- Text inputs -->
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">姓名</div>
                <div class="item-input">
                  <input type="text" v-model.trim="customerName" placeholder="姓名">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">电话</div>
                <div class="item-input">
                  <input type="text" v-model.trim="Mobile" placeholder="电话">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">单位</div>
                <div class="item-input">
                  <input class="open-popup open-enterprise" data-popup=".popup-enterprise" type="text"
                         placeholder="单位名称" id="enterpriseName" v-model.trim="addEnterprise" readonly unselectable="on">
                </div>
              </div>
            </div>
          </li>
          <li class="align-top">
              <div style="margin-left: .7rem;margin-top: .7rem">
                在线留言
              </div>
              <div class="item-input">
                <textarea placeholder="我们将会为您提供更多服务,如有问题，请致电400-621-0302"  v-model.trim="message" style="margin-left: .5rem;margin-top: .5rem" ></textarea>
              </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div class="col-100" >
            <a @click="submit" class="button button-big button-fill button-success"  style="background-color:  #0A3584">提交</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import $ from 'jquery'
//  import EMKT from '../../../emkt'
  import {mapState, mapMutations} from 'vuex'
  export default {
    mounted () {
      let _this = this
      $(document).on('close', function () {
        _this.addEnterprise = _this.enterpriseInfo.enterpriseName
      })
    },
    created () {
    },
    data () {
      return {
        customerName: '',
        Mobile: '',
        message: '',
        addEnterprise: '',
        isReceivePromotion: true,
        error: '出错了'
      }
    },
    computed: {
      ...mapState([
        'enterpriseInfo'
      ])
    },
    watch: {
    },
    methods: {
      ...mapMutations([
        'LOGIN_STATE_UPDATE', 'CLIENT_INFO', 'MYORDER_UPDATE'
      ]),
      submit () {
        let _this = this
        var leaveComment = {}
        leaveComment.mobile = _this.Mobile
        leaveComment.message = _this.message
        leaveComment.customerName = _this.customerName
        leaveComment.enterpriseName = _this.addEnterprise
        if (_this.Mobile === '' || !/^1[3-9]{1}[0-9]{9}$/.test(_this.Mobile)) {
          alert('手机号码有误')
          return
        }
        _this.gcapi('submitLeaveComment', leaveComment).then((res) => {
          console.log(res)
          if (res.body.message === '') {
            _this.Mobile = ''
            _this.message = ''
            _this.customerName = ''
            _this.addEnterprise = ''
            alert('您的留言已提交')
          } else {
            alert(res.body.message)
          }
        })
      },
      goback () {
        this.$router.go(-1)
      }
    }
  }
</script>


<style scoped>
  .error {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }
  .fill-grey{
    background: grey;
  }

</style>



// WEBPACK FOOTER //
// contactUs.vue?31e8f840